import moment from "moment";
import { useAppSelector } from "../../../redux/hooks";

export interface DashboardFilters {
  start_date: string;
  end_date: string;
  pre_start_date: string;
  pre_end_date: string;
  empty: boolean;
  market_place: string;
  channel: string;
}

export const useLiveDashboardFilters = (daysAgo = 1) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const channel = useAppSelector((state) => state.channel.currentChannel);

  const dt = moment().format("YYYY-MM-DD");
  const yt = moment().subtract(daysAgo, "days").format("YYYY-MM-DD");

  const filters = {
    start_date: dt,
    end_date: dt,
    pre_start_date: yt,
    pre_end_date: yt,
    empty: true,
    market_place: marketPlace,
    channel,
  };

  return filters;
};
